import { render, staticRenderFns } from "./FileChooserBtn.vue?vue&type=template&id=4fe37124&"
import script from "./FileChooserBtn.vue?vue&type=script&lang=ts&"
export * from "./FileChooserBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports